export const SITE_URL = 'https://www.cuisinemdfagadir.com';
export const SITE_NAME = 'Cuisine MDF Agadir';
export const PHONE = '+212 661-691450';
export const WHATSAPP = '212661691450';
export const EMAIL = 'contact@cuisinemdfagadir.com';
export const ADDRESS = 'Rue Mouadfine, Inzgane, Agadir, Maroc';

export const ROUTES = {
  HOME: '/',
  BLOG: '/blog',
  CONTACT: '/contact',
  SITEMAP: '/plan-du-site',
  SERVICES_BASE: '/services',
  SERVICES: {
    CUISINE_MDF: '/services/cuisine-mdf',
    CUISINE_MODERNE: '/services/cuisine-moderne',
    CUISINE_SUR_MESURE: '/services/cuisine-sur-mesure',
    PLACARD_DRESSING: '/services/placard-dressing',
    CUISINE_EQUIPEE: '/services/cuisine-equipee',
  },
} as const;

/** Backward-compat alias */
export const ROUTE_PATHS = {
  HOME: ROUTES.HOME,
  CUISINE_MDF: ROUTES.SERVICES.CUISINE_MDF,
  CUISINE_MODERNE: ROUTES.SERVICES.CUISINE_MODERNE,
  CUISINE_SUR_MESURE: ROUTES.SERVICES.CUISINE_SUR_MESURE,
  PRIX: '/prix-cuisine-agadir',
  REALISATIONS: '/realisations',
  CONTACT: ROUTES.CONTACT,
  BLOG: ROUTES.BLOG,
  BLOG_ARTICLE: '/blog/:slug',
} as const;

export const UNSPLASH = {
  // Hero — WebP + qualité réduite + auto=format
  HERO:       'https://images.unsplash.com/photo-1771371282665-545256b20dca?w=1200&q=65&fm=webp&auto=format',
  // Images services — taille et qualité optimisées
  CUISINE1:   'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=560&q=60&fm=webp&auto=format',
  CUISINE2:   'https://images.unsplash.com/photo-1565538810643-b5bdb714032a?w=560&q=60&fm=webp&auto=format',
  CUISINE3:   'https://images.unsplash.com/photo-1556909172-54557c7e4fb7?w=560&q=60&fm=webp&auto=format',
  CUISINE4:   'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=560&q=60&fm=webp&auto=format',
  CUISINE5:   'https://images.unsplash.com/photo-1583845112203-29329902332e?w=560&q=60&fm=webp&auto=format',
  CUISINE6:   'https://images.unsplash.com/photo-1556909212-d5b604d0c90d?w=560&q=60&fm=webp&auto=format',
  MODERNE1:   'https://images.unsplash.com/photo-1556909172-54557c7e4fb7?w=560&q=60&fm=webp&auto=format',
  MODERNE2:   'https://images.unsplash.com/photo-1600585154526-990dced4db0d?w=560&q=60&fm=webp&auto=format',
  DRESSING1:  'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=560&q=60&fm=webp&auto=format',
  DRESSING2:  'https://images.unsplash.com/photo-1595526114035-0d45ed16cfbf?w=560&q=60&fm=webp&auto=format',
  BLOG_DEFAULT: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=400&q=55&fm=webp&auto=format',
};
